import { lazy } from 'react'

const RoleList = lazy(() => import('@/pages/Role/List'))
const RoleForm = lazy(() => import('@/pages/Role/Form'))

const roleRoute = {
  path: 'role',
  meta: { title: '角色管理', icon: 'TeamOutlined', permission: 'role:view' },
  children: [
    {
      path: 'list',
      element: <RoleList />,
      meta: { title: '角色列表', permission: 'role:list' },
    },
    {
      path: 'add',
      element: <RoleForm />,
      meta: { title: '添加角色', permission: 'role:add' },
    },
    {
      path: 'edit/:id',
      element: <RoleForm />,
      meta: { title: '编辑角色', permission: 'role:edit' },
    },
  ],
}

export default roleRoute
